export interface CardDepositModalState {
  isLoading: boolean;
}

export const PAYMENT_WIDGET_MESSAGE_TYPES = {
  PAYMENT_ERROR: 'payment_error',
  PAYMENT_SUCCESS: 'payment_success',
  WIDGET_CLOSE: 'widgetClose',
} as const;

export type PaymentWidgetMessageType =
  (typeof PAYMENT_WIDGET_MESSAGE_TYPES)[keyof typeof PAYMENT_WIDGET_MESSAGE_TYPES];

export const PAYMENT_WIDGET_MESSAGE_STATUSES = {
  SUCCESS: 'success',
  FAILED: 'fail',
} as const;

export type PaymentWidgetMessageStatus =
  (typeof PAYMENT_WIDGET_MESSAGE_STATUSES)[keyof typeof PAYMENT_WIDGET_MESSAGE_STATUSES];

export type PaymentWidgetMessage = {
  type?: PaymentWidgetMessageType;
  message?: string;
  payload?: {
    source: string;
    status: PaymentWidgetMessageStatus;
  };
};
